

export default async ({
    Authentication,
    callbackCorrecto,
    errorCallback
}) => {
    const Auth = new Authentication();     
    try {
        let user = await Auth.updateUser();
        callbackCorrecto(user);
    } catch(error) {    
        console.log(error);
         
        errorCallback(error);

    }
};